import { LineWrapper } from "./style";

const Line = ({ big }) => {
  return <LineWrapper size={big}></LineWrapper>;
};

export default Line;
